import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Col, Typography } from "antd";

import { useKits, useTableKits } from "../hooks";
import Table from "../../../shared/components/ui/Table";
import { kitsService } from "../../../shared/services";
import { DataKits } from "../../../redux/@types";
import { TableColumns } from "../../../shared/components/ui/Table/types";

const { Title } = Typography;

export const TableKits = () => {
  const { changeKitForUpdate, showDeleteConfirm } = useTableKits();
  const { setTableProps, updateStatus, isLoading } = useKits();

  const columns: TableColumns<DataKits> = [
    {
      title: "ID",
      width: 3,
      dataIndex: "id",
      key: "id",
      filterType: "text",
    },
    {
      title: "Nombre",
      width: 9,
      dataIndex: "name",
      key: "name",
      filterType: "text",
    },
    {
      title: "Audiencia",
      width: 7,
      dataIndex: "audience",
      key: "audience",
      filterType: "text",
    },
    {
      title: "Precio",
      width: 6,
      dataIndex: "price",
      key: "price",
      filterType: "text",
    },
    {
      title: "Destacado",
      width: 5,
      dataIndex: "featured",
      key: "featured",
      render: (_, item) => {
        const featured = item.featured === true || item.featured === 'true';
        return featured ? 'Sí' : 'No';
      },
    },
    {
      title: "Estado",
      width: 7,
      dataIndex: "status",
      key: "status",
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <button
            disabled={isLoading}
              onClick={()=>{
                if(item.status === "active"){
                  updateStatus("inactive", item.id)
                }else if( item.status === "inactive"){
                  updateStatus("active", item.id)
                }
              }}
              style={{
                display: "flex",
                padding: "5px 27px",
                borderWidth: 0,
                cursor: "pointer",
                borderRadius: "20px",
                backgroundColor:
                  item.status === "active" ? "#4bd542" : "#ff4d4f",
              }}
            >
              <Title
                style={{
                  marginBottom: "1.5px",
                  color: "white",
                }}
                level={5}
              >
                {item.status}
              </Title>
            </button>
          </Col>
        );
      },
      filters: [
        {
          text: "Activo",
          value: "active",
        },
        {
          text: "Inactivo",
          value: "inactive",
        },
      ],
    },
    {
      title: "Acciones",
      key: "operation",
      fixed: "right",
      width: 6,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <Button
              type="primary"
              shape="circle"
              onClick={() => changeKitForUpdate(item)}
              icon={<EditOutlined />}
              size="large"
            />
            <Button
              type="primary"
              danger
              onClick={() => showDeleteConfirm(item.id, `${item.name}`)}
              shape="circle"
              icon={<DeleteOutlined />}
              size="large"
            />
          </Col>
        );
      },
    },
  ];

  return (
    <Table<DataKits>
      columns={columns}
      fetchQueryProps={{
        $sort: { id: -1 },
      }}
      service={kitsService}
      onLoad={setTableProps}
    />
  );
};
